module.exports = "/_next/static/images/game-3-fingerprint-part-2-wrong-red-87c53245848c2f0579d4fb1d0ef90610.png";